  import React, {
    useEffect,
    useState,
    useCallback,
    useMemo,
  } from "react";
  import { Row, Col, Card } from "react-bootstrap";
  import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
  import { useDispatch, useSelector } from "react-redux";
  import {
    ESCALATION_EXECUTION_LIST,
  } from "../../../../shared/constants/Constants";
  import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
  import {

    loadEscalationExecutionListRowCountRequest,
    loadEscalationExecutionListRequest,
  } from "../redux/Actions";
  import ServerSideListView from "../../../../shared/components/listview/ServerSideListView";
  import { addTableFilter } from "../../../table_filters_redux/Actions";
  import TablePaging from "../../../../shared/components/TablePaging";

  const EscalationExecutionList = () => {
    const { escalationExecutionData, rowCount, loading } = useSelector(
      (store) => store.escalationExecutionList
    );

    console.log("escalationExecutionData", escalationExecutionData);
    let dispatch = useDispatch();
    let navigate = useNavigate();
    let location = useLocation();
    let [query] = useSearchParams();
    const [escalationExecutionList, setEscalationExecutionList] = useState([]);
    useEffect(() => {
      if (escalationExecutionData) setEscalationExecutionList(escalationExecutionData);
    }, [escalationExecutionData]);

    useEffect(() => {
      dispatch(loadEscalationExecutionListRowCountRequest());
    }, [dispatch]);

    let escalationFilterObj = {};
    // Server Side
    const exportTitle = ESCALATION_EXECUTION_LIST;
    let tableFilterKey = useMemo(
      () => location.pathname + "/" + exportTitle,
      [location]
    );
    let { tableFilters } = useSelector((state) => state.tableFilter);
    if (query.get("filter") && query.get("filter") !== "none") {
      escalationFilterObj = {
        ...escalationFilterObj,
        ...JSON.parse(query.getAll("filter")),
      };
    }

    let [filterAndPage, setFilterAndPage] = useState(
      tableFilters[tableFilterKey] && !query.get("filter")
        ? tableFilters[tableFilterKey]
        : {
            filter: JSON.stringify(escalationFilterObj),
            page: 1,
            sort: "null",
          }
    );

    const filterCallback = useCallback(
      (newFilters) => {
        const newFilterAndPage = {
          filter: JSON.stringify(newFilters.filter || {}),
          page: 1,
          sort: JSON.stringify(newFilters.sort || null),
        };

        setFilterAndPage(newFilterAndPage);

        dispatch(
          loadEscalationExecutionListRowCountRequest({
            filter: JSON.parse(newFilterAndPage.filter),
          })
        );
      },
      [dispatch]
    );

    useEffect(() => {
      dispatch(addTableFilter(tableFilterKey, filterAndPage));
      dispatch(
        loadEscalationExecutionListRequest({
          filter: JSON.parse(filterAndPage.filter),
          page: filterAndPage.page,
          sort: JSON.parse(filterAndPage.sort),
        })
      );
    }, [filterAndPage, dispatch]);

    const columnDefs = [
      {
        display_name: "ID",
        field: "id",
        type: "number",
        hide: true,
      },
      {
        display_name: "Ticket Number",
        field: "ticket_number",
        type: "text",
        width: 180,
        pinned: "left",
      },
      {
        display_name: "Rule Name",
        field: "rule_name",
        type: "text",
        width: 220,
      },
      {
        display_name: "Executed At",
        field: "executed_at",
        type: "date",
        width: 200,
        sort: true,
      },
      {
        display_name: "Execution Mode",
        field: "execution_mode",
        type: "text",
        width: 160,
      },
      {
        display_name: "Executed By",
        field: "executed_by",
        type: "number",
        width: 120,
      },
      {
        display_name: "Execution Status",
        field: "execution_status",
        type: "text",
        width: 140,
      },
      {
        display_name: "Notification Status",
        field: "notification_status",
        type: "text",
        width: 160,
      },
      {
        display_name: "Error Message",
        field: "error_message",
        type: "text",
        width: 220,
      },
    ];

    const rowClick = useCallback(
      (row) => {
        console.log("row clicked:", row.data);
      },
      [navigate]
    );

    return (
      <>
        <Row className="detailsPageHeader">
          <Col>
            <Breadcrumbs
              children={[{ label: ESCALATION_EXECUTION_LIST }]}
            />
          </Col>

        </Row>

        <Row>
          <Card className="table-card">
            <Card.Body>
              <ServerSideListView
                exportTitle={ESCALATION_EXECUTION_LIST}
                columnNames={columnDefs}
                rowData={Array.isArray(escalationExecutionData) ? escalationExecutionData : []}
                shouldSetNextPrevIds
                rowClick={rowClick}
                filterCallback={filterCallback}
                filterString={filterAndPage.filter}
                sort={filterAndPage.sort}
                tableHeight="70vh"
                loading={loading}
              />
            </Card.Body>

            <Row>
              <Col />
              <Col sm="auto" />
              <Col sm="auto">
                <TablePaging
                  page={filterAndPage.page}
                  setPage={(num) =>
                    setFilterAndPage({ ...filterAndPage, page: num })
                  }
                  total={rowCount}
                  pageSize={filterAndPage.pageSize}
                />
              </Col>
            </Row>
          </Card>
        </Row>
      </>
    );
  };

  export default EscalationExecutionList;
